import axios from 'axios';
import { JsonResponse } from 'core/models/response';
import { Committee, CommitteeListResponse, CreateCommitteePayload } from '../models/committee';

export const onGetCommitteesList = async (page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<CommitteeListResponse>>('dashboard/committees', {
			params: { page },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetActiveCommittees = async () => {
	try {
		const response = await axios.get<JsonResponse<Committee[]>>(`dashboard/committees/active-committees`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetCommitteeById = async (id: string) => {
	try {
		const response = await axios.get<JsonResponse<Committee>>(`dashboard/committees/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCreateCommittee = async (payload: CreateCommitteePayload) => {
	try {
		const response = await axios.post<JsonResponse<Committee>>(`dashboard/committees`, payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onAppointCommittee = async (id: string, verified_using: 'password' | 'otp', code: string) => {
	try {
		const response = await axios.post<JsonResponse<Committee>>(`dashboard/committees/${id}/appoint`, {
			verified_using,
			[verified_using]: code,
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSendCommitteeOTP = async (id: string) => {
	try {
		const response = await axios.post<JsonResponse<Committee>>(`dashboard/committees/${id}/send-otp`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onDeleteCommittee = async (id: number) => {
	try {
		const response = await axios.delete<JsonResponse<Committee>>(`dashboard/committees/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSendTerminateCommitteeOTP = async (id: number) => {
	try {
		const response = await axios.post(`dashboard/committees/${id}/send-terminate-otp`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onTerminateCommittee = async (id: number, password: string, verified_using: 'password' | 'otp') => {
	try {
		const response = await axios.post(`dashboard/committees/${id}/terminate`, { password, verified_using });
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onExtendCommittee = async (id: number, additional_years: number) => {
	try {
		const response = await axios.post(`dashboard/committees/${id}/extend`, { additional_years });
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
